module.exports = __webpack_public_path__ + "img/pentagon.dd4c56f7.svg";